import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'
import '../../assets/scripts/select';

var swiper1 = new Swiper(".section1 .mySwiper", {
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  on: {
    init: function(swiper){
      $('.ny-nav .swiper .swiper-slide').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.ny-nav .swiper .swiper-slide').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },
});

$(document).ready(function(){
  $('.ny-nav .swiper .swiper-slide').on('click',function(){
    let index = $(this).index()
    swiper1.slideTo(index)
  })
  if(window.location.href.split('?').length > 1){
    let page = window.location.href.split('?')[1]
    let index = page.split('=')[1]
    swiper1.slideTo(index)

    $('.mob-tab a').eq(index).addClass('on')
  }else{
    $('.mob-tab a').eq(0).addClass('on')
  }
})

$('.mob-tab a').on('click',function(){
  let index = $(this).index()
  $(this).addClass('on').siblings().removeClass('on')
  swiper1.slideTo(index)
})

